
<template lang="pug">
  svg(:class="iconClass", :style="iconStyle")
    use(xmlns:xlink="http://www.w3.org/1999/xlink", :xlink:href="iconName")
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      name: String,
      icon: String,
      height: String,
      width: String,
      size: {
        type: String,
        default: '24px',
      }
    },
    computed: {
      iconClass () {
        let iconClass = { 'icon': true };

        iconClass[`icon--${this.name}`] = true;

        return iconClass
      },
      iconStyle () {
        return {
          'height': this.height ? this.height : this.size,
          'width': this.width ? this.width : this.size,
        }
      },
      iconName () {
        return `#${this.name}`
      }
    }
  }
</script>

<style lang="scss">
  .icon {
    fill: $text--main;
  }
</style>

<style scoped lang="scss">
  .icon {
    transition: 0.3s ease all;

    &--underline {
      transform: translateY(22%);
    }

    h1 &, h2 &, h3 &, h4 &, h5 &, h6 &, p & {
      letter-spacing: 1px;
      vertical-align: sub;
    }
  }
</style>
